export default {
  en: {
    addProduct: 'Add product',
    createTitle: 'New product',
    editTitle: 'Edit product',
    success: 'Product saved',
    updateSuccess: 'Changes saved',
    deleteSuccess: 'Product deleted',
    deleteConfirm: 'Delete product “{title}”? This cannot be undone.',
    categoryCreated: 'Category created',
    uncategorized: 'Without category',
    stockUnlimited: 'Not tracked',
    stockInStock: 'In stock {count} pcs',
    actionsAria: 'Product actions',
    disable: 'Disable',
    enable: 'Enable',
    edit: 'Edit',
    delete: 'Delete',
    errorLoadProducts: 'Could not load products',
    paginationAria: 'Products pagination',
    paginationNext: 'Next pages',
    fields: {
      stock: 'Stock',
      stockUnlimited: 'Not tracked',
    },
    validation: {
      stockRequired: 'Enter stock quantity',
      stockInteger: 'Stock must be an integer',
      stockMin: 'Stock cannot be negative',
    },
  },
  ru: {
    addProduct: 'Добавить товар',
    createTitle: 'Новый товар',
    editTitle: 'Редактирование товара',
    success: 'Товар сохранён',
    updateSuccess: 'Изменения сохранены',
    deleteSuccess: 'Товар удалён',
    deleteConfirm: 'Удалить товар «{title}»? Это действие нельзя отменить.',
    categoryCreated: 'Категория создана',
    uncategorized: 'Без категории',
    stockUnlimited: 'Без учета',
    stockInStock: 'В наличии {count} шт',
    actionsAria: 'Действия с товаром',
    disable: 'Отключить',
    enable: 'Включить',
    edit: 'Редактировать',
    delete: 'Удалить',
    errorLoadProducts: 'Не удалось загрузить товары',
    paginationAria: 'Пагинация товаров',
    paginationNext: 'Следующие страницы',
    fields: {
      stock: 'Остаток',
      stockUnlimited: 'Без учета',
    },
    validation: {
      stockRequired: 'Укажите остаток',
      stockInteger: 'Остаток должен быть целым числом',
      stockMin: 'Остаток не может быть отрицательным',
    },
  },
}
